import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SourceListComponent } from '../list/source-list.component';

@Component({
  selector: 'exam-source-list-container',
  template: ` <exam-source-list /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SourceListComponent],
  standalone: true,
})
export class SourceListContainerComponent {}
